var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 60.2778C70 65.6483 65.6483 70 60.2778 70H9.72222C4.35361 70 0 65.6483 0 60.2778V9.72222C0 4.35167 4.35361 0 9.72222 0H60.2778C65.6483 0 70 4.35167 70 9.72222V60.2778Z",
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1621 38.0667C50.9305 36.3417 49.1495 35.1533 46.8568 34.5208C46.8568 34.5208 48.7895 33.8117 50.5326 31.1667C51.5747 29.48 52.1053 27.4483 52.1053 25.0717C52.1053 20.9508 50.6274 17.7883 47.6716 15.6225C44.7158 13.4567 41.3811 12 35.7158 12H18V58H37.7621C43.1242 57.9617 47.16 56.7925 49.9074 54.55C52.6358 52.2692 54 48.8958 54 44.3917C54 41.9 53.3937 39.7917 52.1621 38.0667ZM29.3684 19.6667C29.3684 19.6667 37.2695 19.6667 37.4211 19.6667C40.3011 19.6667 42.6316 22.0242 42.6316 24.9375C42.6316 27.8508 40.3011 30.2083 37.4211 30.2083C37.2695 30.2083 29.3684 30.2083 29.3684 30.2083V19.6667ZM38.8421 50.3333H29.3684V38.8333H38.8421C41.9874 38.8333 44.5263 41.4017 44.5263 44.5833C44.5263 47.765 41.9874 50.3333 38.8421 50.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.0adc581ec909a95d4b1ea024bf554c8c.svg";
export { ForwardRef as ReactComponent };